/**
 * Shared visual tokens for RotoGPT charts (dark card theme).
 * Change colors here to update all chart components at once.
 */
export const chartTheme = {
  surface: "#161616", // chart card + canvas background
  edge: "#272727", // chart card border
  ink: "#F2F2F2", // primary text (titles)
  muted: "#9A9A9A", // secondary text (ticks, legend, Zoom)
  faint: "#6B6B6B", // tertiary / meta text
  ember: "#FF6A1A", // accent (Reset, primary series)
  seriesMuted: "#8A8A8A", // secondary series (League Avg / RB) — solid gray so tooltip/legend swatch matches the bars
  grid: "rgba(255, 255, 255, 0.06)", // grid lines
  zeroLine: "rgba(255, 255, 255, 0.18)", // brighter line at y=0
  borderRadius: "14px", // chart card corner radius
} as const;
